var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import * as actions from '../../store/orgDevPlan/actions';
import { makeSelectDevPlans, makeSelectActiveDeveloperPlan, makeSelectActiveBundles, selectUpdatedAddons, selectDevPlanBundlesOrg, selectDevPlanInvoiceDetailsOrg, selectDevPlanInvoiceDetails, selectPurchaseDevPlanBundleLoading, selectPurchaseDevPlanBundleError, selectProratedAmountForAddons, } from '../../store/orgDevPlan/selectors';
import { makeSelectOrganization } from '../Root/selectors';
import { Helmet } from 'react-helmet';
import { PageHeader, PageHeaderTitle, PageWrapper, } from '../../components/Page';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import AddonsComponent from '../../components/DeveloperPlans/AddonsComponent';
import { LoadingSpinner } from '../../components/base';
import { LoaderPosition } from '../../components/Page/styles';
import { useErrorToast, useSuccessToast } from '../../utils/hooks/toast';
var OrganizationDeveloperPlanAddons = function (_a) {
    var organization = _a.organization, bundles = _a.bundles, bundlesOrg = _a.bundlesOrg, listBundles = _a.listBundles, activeDeveloperPlan = _a.activeDeveloperPlan, getActiveBundles = _a.getActiveBundles, activeBundles = _a.activeBundles, updatedAddons = _a.updatedAddons, updateActiveBundles = _a.updateActiveBundles, updateUpdatedAddons = _a.updateUpdatedAddons, listDeveloperPlans = _a.listDeveloperPlans, addBundlesToDevPlanOrg = _a.addBundlesToDevPlanOrg, removeBundlesFromDevPlanOrg = _a.removeBundlesFromDevPlanOrg, getDevPlanInvoiceDetails = _a.getDevPlanInvoiceDetails, devPlanInvoiceDetails = _a.devPlanInvoiceDetails, devPlanInvoiceDetailsOrg = _a.devPlanInvoiceDetailsOrg, purchase_dev_plan_bundle_loading = _a.purchase_dev_plan_bundle_loading, purchase_dev_plan_bundle_error = _a.purchase_dev_plan_bundle_error, getProratedAmountForAddons = _a.getProratedAmountForAddons, proratedAmountForAddons = _a.proratedAmountForAddons;
    var params = useParams();
    var _b = params.organizationId, organizationId = _b === void 0 ? '' : _b;
    var crumbs = [{ to: '', text: 'Developer Plans' }];
    if (organizationId) {
        var organizationName = organization ? organization.name : 'Loading...';
        crumbs = [
            {
                to: '/organizations',
                text: 'Organizations',
            },
            {
                to: "/organizations/".concat(organizationId),
                text: organizationName,
            },
            {
                to: "/organizations/".concat(organizationId, "/developerPlans/usage"),
                text: 'Usage',
            },
            {
                to: '',
                text: 'Addons',
            },
        ];
    }
    useEffect(function () {
        if (organizationId) {
            listBundles(organizationId, activeDeveloperPlan.id);
            getActiveBundles(organizationId);
            listDeveloperPlans(organizationId);
            getDevPlanInvoiceDetails(organizationId);
            updateUpdatedAddons([]);
        }
    }, [
        getActiveBundles,
        listDeveloperPlans,
        listBundles,
        getDevPlanInvoiceDetails,
        organizationId,
        activeDeveloperPlan.id,
        updateUpdatedAddons,
    ]);
    useErrorToast('An error occurred while updating developer plan', [
        !purchase_dev_plan_bundle_loading,
        purchase_dev_plan_bundle_error,
    ]);
    useSuccessToast('Bundles successfully Updated', [
        !purchase_dev_plan_bundle_loading,
        !purchase_dev_plan_bundle_error,
    ]);
    var onUpdateAddons = function (updatedAddons) { return __awaiter(void 0, void 0, void 0, function () {
        var addedBundles, removedBundles, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    addedBundles = [], removedBundles = [];
                    (updatedAddons || []).map(function (entity) {
                        entity.quantity > 0
                            ? addedBundles.push(entity)
                            : removedBundles.push(entity);
                    });
                    _a = addedBundles.length;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, addBundlesToDevPlanOrg(organizationId, addedBundles.map(function (entity) {
                            var _a;
                            return ({
                                bundle: (_a = entity.bundle) === null || _a === void 0 ? void 0 : _a.id,
                                quantity: entity.quantity,
                            });
                        }) || [])];
                case 1:
                    _a = (_c.sent());
                    _c.label = 2;
                case 2:
                    _a;
                    _b = removedBundles.length;
                    if (!_b) return [3 /*break*/, 4];
                    return [4 /*yield*/, removeBundlesFromDevPlanOrg(organizationId, removedBundles.map(function (entity) {
                            var _a;
                            return ({
                                bundle: (_a = entity.bundle) === null || _a === void 0 ? void 0 : _a.id,
                                quantity: entity.quantity * -1,
                            });
                        }) || [])];
                case 3:
                    _b = (_c.sent());
                    _c.label = 4;
                case 4:
                    _b;
                    updateUpdatedAddons([]);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(PageWrapper, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Developer Plans" }) }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), activeBundles && bundlesOrg === organizationId ? (_jsx(AddonsComponent, { bundles: bundles, activeBundles: activeBundles, updatedAddons: updatedAddons, updateActiveBundles: updateActiveBundles, updateUpdatedAddons: updateUpdatedAddons, activeDeveloperPlan: activeDeveloperPlan, onUpdateAddons: onUpdateAddons, getProratedAmountForAddons: function (bundles) {
                    return getProratedAmountForAddons(organizationId, bundles);
                }, devPlanInvoiceDetails: devPlanInvoiceDetailsOrg === organizationId
                    ? devPlanInvoiceDetails
                    : {}, proratedAmountForAddons: proratedAmountForAddons })) : (_jsx(LoaderPosition, { children: _jsx(LoadingSpinner, {}) }))] }));
};
var mapStateToProps = function (state) { return (__assign(__assign({ organization: makeSelectOrganization()(state) }, makeSelectDevPlans(state)), { bundlesOrg: selectDevPlanBundlesOrg(state), activeDeveloperPlan: makeSelectActiveDeveloperPlan(state), activeBundles: makeSelectActiveBundles(state), updatedAddons: selectUpdatedAddons(state), devPlanInvoiceDetails: selectDevPlanInvoiceDetails(state), devPlanInvoiceDetailsOrg: selectDevPlanInvoiceDetailsOrg(state), purchase_dev_plan_bundle_loading: selectPurchaseDevPlanBundleLoading(state), purchase_dev_plan_bundle_error: selectPurchaseDevPlanBundleError(state), proratedAmountForAddons: selectProratedAmountForAddons(state) })); };
var mapDispatchToProps = function (dispatch) { return ({
    listDeveloperPlans: function (orgId) {
        dispatch(actions.listDeveloperPlansOrg(orgId));
    },
    listBundles: function (OrgId, DevPlanId) {
        dispatch(actions.listBundlesPurchasableByOrg(OrgId, DevPlanId));
    },
    getActiveBundles: function (OrgId) { return dispatch(actions.getActiveBundles(OrgId)); },
    addBundlesToDevPlanOrg: function (OrgId, bundles) {
        dispatch(actions.addBundlesToDevPlanOrg(OrgId, bundles));
    },
    removeBundlesFromDevPlanOrg: function (OrgId, bundles) {
        dispatch(actions.removeBundlesFromDevPlanOrg(OrgId, bundles));
    },
    updateActiveBundles: function (activeBundles) {
        return dispatch(actions.updateActiveBundles(activeBundles));
    },
    updateUpdatedAddons: function (updatedBundles) {
        return dispatch(actions.updateUpdatedAddons(updatedBundles));
    },
    getDevPlanInvoiceDetails: function (OrgId) {
        dispatch(actions.getDevPlanInvoiceDetails(OrgId));
    },
    getProratedAmountForAddons: function (OrgId, bundles) {
        dispatch(actions.getProratedAmountForAddons(OrgId, bundles));
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(OrganizationDeveloperPlanAddons);
